var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upsell-item" }, [
    _c(
      "a",
      {
        staticClass: "grid-view-item__link grid-view-item__image-container",
        attrs: {
          href: _vm.url,
          title: `Product: ${_vm.title}`,
          "aria-label": `Product: ${_vm.title}`,
        },
        on: {
          mouseover: function ($event) {
            _vm.hover = _vm.$screen.laptop_up
          },
          mouseleave: function ($event) {
            _vm.hover = false
          },
        },
      },
      [
        _c("div", { staticClass: "grid-view-item__image-wrapper" }, [
          _c("img", {
            staticClass: "vimg lazyload",
            attrs: {
              src: _vm.activeImage.src,
              "data-sizes": "auto",
              alt: _vm.activeImage.alt,
            },
            on: {
              lazyloaded: function ($event) {
                return _vm.$emit("loaded")
              },
            },
          }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "select-variants" },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openVariantSelect,
                  expression: "openVariantSelect",
                },
              ],
              staticClass: "upsell-variant",
            },
            _vm._l(_vm.variantsList, function (variant) {
              return _c(
                "li",
                {
                  key: variant.variantId,
                  class: {
                    active: _vm.checkVariantActive(variant.variantId),
                    notAvailable: variant.available,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addToCart(variant.variantId)
                    },
                  },
                },
                [_c("h6", [_vm._v(_vm._s(variant.title))])]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "upsell-add",
            on: {
              click: function ($event) {
                _vm.openVariantSelect = !_vm.openVariantSelect
              },
            },
          },
          [
            !_vm.active
              ? _c("h6", [_vm._v("Add")])
              : _c("h6", [
                  _vm._v("Added "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.checkIcon) },
                  }),
                ]),
            _vm._v(" "),
            !_vm.openVariantSelect
              ? _c("span", [_vm._v("+")])
              : _c("span", [_vm._v("-")]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("p", { staticClass: "h5 grid-view-item__title" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t"),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "h6 grid-view-item__meta" }, [
      _c("span", {
        staticClass: "product-price__price",
        domProps: { textContent: _vm._s(_vm.$money(_vm.price)) },
      }),
      _vm._v(" "),
      _vm.salePrice
        ? _c("s", {
            staticClass: "visually-hidden",
            domProps: { textContent: _vm._s(_vm.$money(_vm.salePrice)) },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }